import { activeStay, sessionQuery, userStaysQuery, userStaysService } from '@lib/state';
import { useEffect } from 'react';
import { useObservable } from './useObservable';

export function useCurrentStay() {
  const user = useObservable(sessionQuery.currentUser);
  const currentStays = activeStay(useObservable(userStaysQuery.stays));

  useEffect(() => {
    userStaysService.getUserStays();
  }, []);

  return {
    currentStay: !user && currentStays.length > 0 ? undefined : currentStays[0],
    loading: useObservable(userStaysQuery.loading),
  };
}
